import React from "react";
import "./Spinner.css";

/**
 * Small inline spinner ring.
 * size: "sm" (default) | "md" | "lg"
 */
export default function Spinner({ size = "sm", label = "Loading…" }) {
  return (
    <span className={`spinner spinner--${size}`} role="status" aria-label={label}>
      <span className="spinner-ring" />
    </span>
  );
}
